import { DashboardCards } from "./DashboardCards/DashboardCards";
import { DashboardHeader } from "./header/DashboardHeader";

export function SystemAdminLanding() {
  return (

      <main className="flex flex-col gap-5">
        <DashboardHeader />
        <DashboardCards />
      </main>
   
  );
}
